export default __webpack_public_path__ + "e25832a.png";